import { reduce } from 'ramda';

export const isReportNonEmpty = reduce(
  (isNotEmpty, currentSeries) => isNotEmpty || currentSeries.series?.length,
  false
);
